import React from 'react';
import { css } from '@emotion/core';
import { FooterLink } from './read-link';
const Dev = () => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 14 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 0.5V9.5H14V0.5H0ZM1 1.5H13V8.5H1V1.5ZM2 2.5V7.5H3.5C4.327 7.5 5 6.827 5 6V4C5 3.173 4.327 2.5 3.5 2.5H2ZM7 2.5C6.4485 2.5 6 2.9485 6 3.5V6.5C6 7.0515 6.4485 7.5 7 7.5H8V6.5H7V5.5H8V4.5H7V3.5H8V2.5H7ZM8.8455 2.5L9.8875 7.0125C9.9198 7.15072 9.99789 7.27394 10.1091 7.36216C10.2203 7.45037 10.3581 7.49837 10.5 7.49837C10.6419 7.49837 10.7797 7.45037 10.8909 7.36216C11.0021 7.27394 11.0802 7.15072 11.1125 7.0125L12.1545 2.5H11.128L10.5 5.22L9.872 2.5H8.8455ZM3 3.5H3.5C3.63261 3.5 3.75979 3.55268 3.85355 3.64645C3.94732 3.74021 4 3.86739 4 4V6C4 6.13261 3.94732 6.25979 3.85355 6.35355C3.75979 6.44732 3.63261 6.5 3.5 6.5H3V3.5Z" />
  </svg>
);
const Linkedin = () => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.2453 0.75H1.75469C1.2 0.75 0.75 1.2 0.75 1.75469V12.2453C0.75 12.8 1.2 13.25 1.75469 13.25H12.2453C12.8 13.25 13.25 12.8 13.25 12.2453V1.75469C13.25 1.2 12.8 0.75 12.2453 0.75V0.75ZM12.2453 12.25C5.24844 12.2484 1.75 12.2469 1.75 12.2453C1.75156 5.24844 1.75313 1.75 1.75469 1.75C8.75156 1.75156 12.25 1.75313 12.25 1.75469C12.2484 8.75156 12.2469 12.25 12.2453 12.25ZM2.60313 5.43594H4.45781V11.4016H2.60313V5.43594ZM3.53125 4.62031C4.12344 4.62031 4.60625 4.13906 4.60625 3.54531C4.60625 3.40414 4.57844 3.26435 4.52442 3.13393C4.4704 3.0035 4.39121 2.885 4.29139 2.78517C4.19157 2.68535 4.07306 2.60617 3.94263 2.55214C3.81221 2.49812 3.67242 2.47031 3.53125 2.47031C3.39008 2.47031 3.25029 2.49812 3.11987 2.55214C2.98944 2.60617 2.87093 2.68535 2.77111 2.78517C2.67129 2.885 2.5921 3.0035 2.53808 3.13393C2.48406 3.26435 2.45625 3.40414 2.45625 3.54531C2.45469 4.13906 2.93594 4.62031 3.53125 4.62031ZM7.47344 8.45C7.47344 7.67187 7.62187 6.91875 8.58594 6.91875C9.53594 6.91875 9.55 7.80781 9.55 8.5V11.4016H11.4031V8.12969C11.4031 6.52344 11.0562 5.2875 9.17969 5.2875C8.27812 5.2875 7.67344 5.78281 7.425 6.25156H7.4V5.43594H5.62031V11.4016H7.47344V8.45Z" />
  </svg>
);
const Github = () => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 22 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 21.9999V18.1299C15.0375 17.6531 14.9731 17.1737 14.811 16.7237C14.6489 16.2737 14.3929 15.8634 14.06 15.5199C17.2 15.1699 20.5 13.9799 20.5 8.51994C20.4997 7.12376 19.9627 5.78114 19 4.76994C19.4559 3.54844 19.4236 2.19829 18.91 0.999938C18.91 0.999938 17.73 0.649938 15 2.47994C12.708 1.85876 10.292 1.85876 8 2.47994C5.27 0.649938 4.09 0.999938 4.09 0.999938C3.57638 2.19829 3.54414 3.54844 4 4.76994C3.03013 5.78864 2.49252 7.1434 2.5 8.54994C2.5 13.9699 5.8 15.1599 8.94 15.5499C8.611 15.8899 8.35726 16.2953 8.19531 16.7399C8.03335 17.1844 7.96681 17.658 8 18.1299V21.9999M8 18.9999C3 20.4999 3 16.4999 1 15.9999L8 18.9999Z"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
const Instagram = () => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="
      M7.00007 3.79524C5.22664 3.79524 3.79539 5.22649 3.79539 6.99993C3.79539 8.77337 5.22664 10.2046 7.00007 10.2046C8.77351 10.2046 10.2048 8.77337 10.2048 6.99993C10.2048 5.22649 8.77351 3.79524 7.00007 3.79524ZM7.00007 9.08274C5.8532 9.08274 4.91726 8.1468 4.91726 6.99993C4.91726 5.85305 5.8532 4.91712 7.00007 4.91712C8.14695 4.91712 9.08289 5.85305 9.08289 6.99993C9.08289 8.1468 8.14695 9.08274 7.00007 9.08274ZM10.336 2.91711C9.92195 2.91711 9.58757 3.25149 9.58757 3.66555C9.58757 4.07962 9.92195 4.41399 10.336 4.41399C10.7501 4.41399 11.0844 4.08118 11.0844 3.66555C11.0846 3.56723 11.0653 3.46985 11.0277 3.37899C10.9902 3.28813 10.935 3.20558 10.8655 3.13605C10.796 3.06653 10.7134 3.0114 10.6226 2.97384C10.5317 2.93627 10.4343 2.91699 10.336 2.91711V2.91711ZM13.2469 6.99993C13.2469 6.13743 13.2548 5.28274 13.2063 4.4218C13.1579 3.4218 12.9298 2.5343 12.1985 1.80305C11.4657 1.07024 10.5798 0.843678 9.57976 0.79524C8.71726 0.746803 7.86257 0.754615 7.00164 0.754615C6.13914 0.754615 5.28445 0.746803 4.42351 0.79524C3.42351 0.843678 2.53601 1.0718 1.80476 1.80305C1.07195 2.53587 0.845387 3.4218 0.796949 4.4218C0.748512 5.2843 0.756324 6.13899 0.756324 6.99993C0.756324 7.86086 0.748512 8.71712 0.796949 9.57805C0.845387 10.5781 1.07351 11.4656 1.80476 12.1968C2.53757 12.9296 3.42351 13.1562 4.42351 13.2046C5.28601 13.2531 6.1407 13.2452 7.00164 13.2452C7.86414 13.2452 8.71882 13.2531 9.57976 13.2046C10.5798 13.1562 11.4673 12.9281 12.1985 12.1968C12.9313 11.464 13.1579 10.5781 13.2063 9.57805C13.2563 8.71712 13.2469 7.86243 13.2469 6.99993V6.99993ZM11.8719 10.6843C11.7579 10.9687 11.6204 11.1812 11.4001 11.3999C11.1798 11.6202 10.9688 11.7577 10.6844 11.8718C9.86257 12.1984 7.91101 12.1249 7.00007 12.1249C6.08914 12.1249 4.13601 12.1984 3.31414 11.8734C3.02976 11.7593 2.81726 11.6218 2.59851 11.4015C2.3782 11.1812 2.2407 10.9702 2.12664 10.6859C1.80164 9.86243 1.87507 7.91087 1.87507 6.99993C1.87507 6.08899 1.80164 4.13587 2.12664 3.31399C2.2407 3.02962 2.3782 2.81712 2.59851 2.59837C2.81882 2.37962 3.02976 2.24055 3.31414 2.12649C4.13601 1.80149 6.08914 1.87493 7.00007 1.87493C7.91101 1.87493 9.86414 1.80149 10.686 2.12649C10.9704 2.24055 11.1829 2.37805 11.4016 2.59837C11.6219 2.81868 11.7594 3.02962 11.8735 3.31399C12.1985 4.13587 12.1251 6.08899 12.1251 6.99993C12.1251 7.91087 12.1985 9.86243 11.8719 10.6843Z"
    />
  </svg>
);

const Footer = () => {
  return (
    <div
      css={css`
        width: 100%;
        height: 100px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        background: #303633;
      `}
    >
      <div
        css={css`
          max-width: 800px;
          width: 100%;
          display: flex;
          justify-content: space-around;
          flex-direction: row;
        `}
      >
        <FooterLink href="https://github.com/deevo-sage">
          <Github />
        </FooterLink>
        <FooterLink href="https://www.linkedin.com/in/sidharth-sahni-77951b191/">
          <Linkedin />
        </FooterLink>
        <FooterLink href="https://www.instagram.com/sidharthhsahni/">
          <Instagram />
        </FooterLink>
        <FooterLink href="https://dev.to/deevosage">
          <Dev />
        </FooterLink>
      </div>
    </div>
  );
};
export default Footer;
